import { render, staticRenderFns } from "./Publication.vue?vue&type=template&id=19a2aaa6&scoped=true&lang=pug&"
import script from "./Publication.vue?vue&type=script&lang=js&"
export * from "./Publication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a2aaa6",
  null
  
)

export default component.exports